$(document).ready(function(){
  const optionsSize = $('.product__container').attr('data-option-size');
  const varintTitle = $('.product__container').attr('data-variant-title').trim();
  
  if(optionsSize <= 0){
    console.log('no options');
  }else if(optionsSize == 1){
    //console.log('only one option');
    //console.log(varintTitle);
  // $('.product-gallery--media').hide();
   //$('.product-gallery--media-thumbnail').hide();
    $('.product-gallery--media , .product-gallery--media-thumbnail').each(function(){
       const altText = $(this).find('img').attr('alt');
      
       if(varintTitle != altText.split('-')[0].trim()){
         console.log("matched",altText.split('-')[0] , varintTitle);
         //$(this).remove();
         //$('.product-gallery--viewer').flickity();
         //$('.product-gallery--viewer').flickity('reloadCells');
           //$('.product-gallery').flickity();
          // $('.product-gallery').flickity( 'remove', $(this) );
          //$('.product-gallery').flickity('reloadCells');
       }
    });
    //$('.product-gallery--viewer').flickity();
    
  }else{
    console.log('Multiple options');
    console.log(varintTitle);
  }
});
